import React from 'react'
import useMobileDetect from 'use-mobile-detect-hook'

interface Transaction {
    description: string
    date: string
    impact: string
    type: string[]
    amount: number | string
    icon?: React.ReactNode
}

export function TransactionItem({
    description,
    date,
    impact,
    amount,
    type,
    icon,
}: Transaction) {
    const detectMobile = useMobileDetect()

    const dataClasses = 'not-italic font-light text-sm leading-3 py-4'
    const normalClasses = ' text-gray text-opacity-80 capitalize'
    const enfasisClasses = ' text-black '
    return (
        <tr
            className='border-b border-solid border-gray border-opacity-10 group'
            data-test-id={`transaction-item`}>
            <td className={`${dataClasses} ${enfasisClasses}`}>
                <div className='flex flex-row items-start overflow-visible'>
                    {icon}

                    <div className='w-full text-left break-words truncat'>
                        <p className='mb-1 font-medium text-left text-black break-words text-md truncat'>
                            {description}
                        </p>
                        <p className='m-0 text-xs'>{date}</p>
                    </div>
                </div>
            </td>
            {detectMobile.isDesktop() && (
                <td className={`${dataClasses} ${normalClasses}`}>
                    {type?.length ? type[0] : ''}
                </td>
            )}

            <td
                className={`${dataClasses} ${enfasisClasses} font-medium text-right whitespace-nowrap ${
                    impact === 'Credit' ? 'text-success' : ''
                }`}>
                {impact === 'Debit' ? '-' : ''}
                {amount}
            </td>
        </tr>
    )
}
